import {SessionService} from './../../../../../services/session';
import {Component} from '@angular/core';
import {ViewController, NavParams, AlertController, LoadingController} from 'ionic-angular';
import {ReservationsService} from '../../../../../services/reservations';
import {MembershipService} from '../../../profile/membership/membership.service';
import {LocationsService} from '../../../../../services/locations';

// pwa/app difference: App uses Ionic native calendar

@Component({
  selector: 'page-cancel',
  templateUrl: 'cancel.html'
})
export class CancelPage {

  lesson: any = null;
  reservationId: string = null;
  bookClicked = false;

  constructor(private viewCtrl: ViewController,
              private navParams: NavParams,
              public reservationsService: ReservationsService,
              public alertCtrl: AlertController,
              public loadingCtrl: LoadingController,
              public membershipService: MembershipService,
              public sessionService: SessionService,
              public locationsService: LocationsService) {
    this.lesson = navParams.get('lesson')
    this.reservationId = navParams.get('reservationId')
  }

  ionViewDidLoad() {
    if (!this.lesson.schedule.lessonEndTime) {
      this.lesson.schedule.lessonEndTime = new Date()
      this.lesson.schedule.lessonEndTime.setTime(
        new Date(this.lesson.schedule.lesson_time).getTime() + (this.lesson.schedule.length * 60 * 1000)
      );
    }
  }

  dismissModal(isCancelled: boolean) {
    this.viewCtrl.dismiss(isCancelled);
  }

  cancelClass() {
    this.bookClicked = true;
    let loading = this.loadingCtrl.create();
    loading.present();
    this.reservationsService.cancelClass(
      this.lesson.gym.id, this.lesson.id, this.lesson.schedule.id, this.reservationId
    )
      .then((message: any) => {
        loading.dismiss();
        this.dismissModal(true);

      })
      .catch(err => {
        this.sessionService.reportError(
          'cancelPage',
          'cancelClass()',
          err
        );
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: err.error.errors[0],
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
            },
          ]
        });
        loading.dismiss();
        alert.present();
        this.bookClicked = false;
      })
  }

  public getClassInfo(info: string): string {
    const hoursToCancel = (this.lesson.schedule.hours_to_cancel || this.membershipService.hoursToCancelClass)
      .toString();
    return info.replace(this.membershipService.hoursToCancelClass.toString(), hoursToCancel)
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/class/cancel/cancel.ts